"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonEditorPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("../events");
const jsoneditor_1 = __importDefault(require("jsoneditor"));
const WIN_EVENT = 'json-editor-save';
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group json-editor-part">
    ${(0, fast_element_1.when)(x => x.label, T.html `<label class="d-block mb-1">${x => x.label.t()}</label>`)}
    <button type="button" class="btn btn-sm btn-outline-secondary" @click="${x => x.openModal()}">
        <i class="simple-icon-pencil me-1"></i>
        ${x => x.value && Object.keys(x.value).length ? 'botTest.editJsonData'.t() : 'botTest.addJsonData'.t()}
    </button>
    ${(0, fast_element_1.when)(x => x.value && Object.keys(x.value).length > 0, T.html `
        <span class="badge bg-success ms-2">${() => 'botTest.jsonDataSet'.t()}</span>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css ``;
const shadowOptions = { "mode": "open" };
let JsonEditorPart = class JsonEditorPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.ignored = 'false';
    }
    connectedCallback() {
        super.connectedCallback();
        this._saveHandler = (e) => {
            const { name, value } = e.detail;
            if (name !== this.name)
                return;
            this.value = value;
            if (this.ignored === 'true')
                return;
            this.$emit(events_1.inputEvents.changed, {
                fieldName: this.name,
                value
            });
        };
        window.addEventListener(WIN_EVENT, this._saveHandler);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener(WIN_EVENT, this._saveHandler);
    }
    openModal() {
        const overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;display:flex;align-items:center;justify-content:center;';
        const dialog = document.createElement('div');
        dialog.style.cssText = 'background:#fff;border-radius:8px;width:700px;max-width:95vw;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;';
        // header
        const header = document.createElement('div');
        header.style.cssText = 'padding:12px 16px;border-bottom:1px solid #ddd;display:flex;justify-content:space-between;align-items:center;font-weight:600;';
        header.textContent = this.label || 'JSON Editor';
        const closeBtn = document.createElement('button');
        closeBtn.textContent = '✕';
        closeBtn.style.cssText = 'background:none;border:none;font-size:18px;cursor:pointer;line-height:1;';
        closeBtn.onclick = () => overlay.remove();
        header.appendChild(closeBtn);
        // editor container
        const editorWrap = document.createElement('div');
        editorWrap.style.cssText = 'flex:1;overflow:hidden;height:400px;min-height:400px;';
        // css
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/css/main.css';
        document.head.appendChild(link);
        // footer
        const footer = document.createElement('div');
        footer.style.cssText = 'padding:12px 16px;border-top:1px solid #ddd;display:flex;justify-content:flex-end;gap:8px;';
        const cancelBtn = document.createElement('button');
        cancelBtn.textContent = 'Cancel';
        cancelBtn.style.cssText = 'padding:6px 16px;border:1px solid #ccc;border-radius:4px;cursor:pointer;background:#fff;';
        cancelBtn.onclick = () => overlay.remove();
        const saveBtn = document.createElement('button');
        saveBtn.textContent = 'Save';
        saveBtn.style.cssText = 'padding:6px 16px;border:none;border-radius:4px;cursor:pointer;background:#467fcf;color:#fff;';
        footer.appendChild(cancelBtn);
        footer.appendChild(saveBtn);
        dialog.appendChild(header);
        dialog.appendChild(editorWrap);
        dialog.appendChild(footer);
        overlay.appendChild(dialog);
        document.body.appendChild(overlay);
        const editor = new jsoneditor_1.default(editorWrap, { mode: 'code' });
        editor.set(this.value || {});
        // focus ace after short delay so it initialises fully
        setTimeout(() => editor.focus(), 100);
        saveBtn.onclick = () => {
            try {
                const json = editor.get();
                window.dispatchEvent(new CustomEvent(WIN_EVENT, { detail: { name: this.name, value: json } }));
                overlay.remove();
            }
            catch (_a) {
                saveBtn.textContent = 'Invalid JSON!';
                setTimeout(() => { saveBtn.textContent = 'Save'; }, 1500);
            }
        };
        overlay.addEventListener('click', (e) => { if (e.target === overlay)
            overlay.remove(); });
    }
    valueChanged(_old, _newVal) { }
    reset() {
        this.value = undefined;
    }
};
exports.JsonEditorPart = JsonEditorPart;
JsonEditorPart.PART_TYPE = 'json-editor';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], JsonEditorPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], JsonEditorPart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], JsonEditorPart.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], JsonEditorPart.prototype, "ignored", void 0);
exports.JsonEditorPart = JsonEditorPart = __decorate([
    (0, client_1.RWSView)('part-json-editor', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], JsonEditorPart);
JsonEditorPart.defineComponent();
